import { defineSelectorFactory } from '@exodus/redux-dependency-injection';
import { createSelector } from 'reselect';
const selectorFactory = (walletAccountNamesSelector, getWalletAccountSelector) => createSelector(walletAccountNamesSelector, getWalletAccountSelector, (walletAccountNames, getWalletAccount) => walletAccountNames.filter((walletAccount) => getWalletAccount(walletAccount)?.isHardware));
const hardwareSelectorDefinition = defineSelectorFactory({
    id: 'hardware',
    selectorFactory,
    dependencies: [
        { selector: 'names' },
        { selector: 'get' },
    ],
});
export default hardwareSelectorDefinition;
